import { observer } from "mobx-react";
import React, { useContext } from "react";
import OrderSettingsPageStoreContext from "../context";
import { FormControl, Paper, Typography } from "../../../../../common/components/libs";
import { InputAdornment, InputLabel } from "@material-ui/core";
import Input from "@material-ui/core/Input";
import { changeEventHandlerDecorator } from "../../../../../common/libs";
import phoneNumberIcon from "../../../../../common/assets/icons/phone.svg"
import instagram from "../../../../../common/assets/icons/instagram.svg"
import websiteIcon from "../../../../../common/assets/icons/website.svg"
import whatsappIcon from "../../../../../common/assets/icons/whatsapp.svg"
import telegramIcon from "../../../../../common/assets/icons/telegram.svg"
import { useTranslation } from "react-i18next";


const ContactInfoBlock = () => {
    const {t} = useTranslation(["general", "menu"]);
    const store = useContext(OrderSettingsPageStoreContext);



    return <>
        <Typography variant={"h3"}  mt={20} >
            {t("menu:orderSettingsPage.contactsAndSocialMedias")}
        </Typography>
        <Typography variant={"body1"} color={'textSecondary'} mb={2}>
            {t("menu:orderSettingsPage.tellAboutHowFindYouInSocialMedias")}
        </Typography>
        <Paper p={5} style={{ maxWidth: 800, width: "100%" }}>

            <FormControl fullWidth  mt={2}>
                <InputLabel htmlFor="name">{t("menu:orderSettingsPage.telephone")}</InputLabel>
                <Input
                    startAdornment={
                        <InputAdornment position="start">
                            <img src={phoneNumberIcon} alt="" />
                        </InputAdornment>
                    }
                    value={store.contactDetails.phoneNumber || ""}
                    onChange={changeEventHandlerDecorator(store.setPhoneNumber.bind(store))}
                />
            </FormControl>


            <FormControl fullWidth  mt={5}>
                <InputLabel htmlFor="name">Whatsapp</InputLabel>
                <Input
                    startAdornment={
                        <InputAdornment position="start">
                            <img src={whatsappIcon} alt=""/>
                        </InputAdornment>
                    }
                    value={store.contactDetails.whatsApp || ""}
                    onChange={changeEventHandlerDecorator(store.setWhatsApp.bind(store))}
                />
            </FormControl>

            <FormControl fullWidth  mt={5}>
                <InputLabel htmlFor="name">Instagram</InputLabel>
                <Input
                    startAdornment={
                        <InputAdornment position="start">
                            <img src={instagram} alt=""/>
                        </InputAdornment>
                    }
                    value={store.contactDetails.instagram || ""}
                    onChange={changeEventHandlerDecorator(store.setInstagram.bind(store))}
                />
            </FormControl>

            <FormControl fullWidth  mt={5}>
                <InputLabel htmlFor="name">Telegram</InputLabel>
                <Input
                    startAdornment={
                        <InputAdornment position="start">
                            <img src={telegramIcon} alt=""/>
                        </InputAdornment>
                    }
                    value={store.contactDetails.telegram || ""}
                    onChange={changeEventHandlerDecorator(store.setTelegram.bind(store))}
                />
            </FormControl>

            <FormControl fullWidth mt={5}>
                <InputLabel htmlFor="name">{t("menu:orderSettingsPage.website")}</InputLabel>
                <Input
                    startAdornment={
                        <InputAdornment position="start">
                            <img src={websiteIcon} alt="websiteIcon"/>
                            <Typography  ml={2} >https://</Typography>
                        </InputAdornment>
                    }
                    value={store.contactDetails.websiteUrl || ""}
                    onChange={changeEventHandlerDecorator(store.setWebsite.bind(store))}
                />
            </FormControl>
        </Paper>
    </>

}


export default observer(ContactInfoBlock)
